(function () {

  function initCompareBags(root) {

    if (!root) return;

    const tabs =
      root.querySelectorAll(
        '[data-compare-tab]'
      );

    const items =
      root.querySelectorAll(
        '[data-compare-item]'
      );

    if (!tabs.length || !items.length) {
      return;
    }

    /*
     * Tránh bind event nhiều lần
     */
    if (
      root.dataset.compareInitialized === 'true'
    ) {
      return;
    }

    root.dataset.compareInitialized =
      'true';

    function setView(view) {

      tabs.forEach(tab => {

        const active =
          tab.dataset.compareTab === view;

        tab.classList.toggle(
          'is-active',
          active
        );

        tab.setAttribute(
          'aria-selected',
          active
            ? 'true'
            : 'false'
        );

      });


      items.forEach(item => {

        const modelImage =
          item.querySelector(
            '.compare-bags__image--model'
          );

        const bagImage =
          item.querySelector(
            '.compare-bags__image--bag'
          );


        if (modelImage) {

          modelImage.classList.toggle(
            'is-active',
            view === 'model'
          );

        }


        if (bagImage) {

          bagImage.classList.toggle(
            'is-active',
            view === 'bag'
          );

        }

      });

    }


    tabs.forEach(tab => {

      tab.addEventListener(
        'click',
        function () {

          setView(
            this.dataset.compareTab
          );

        }
      );

    });


    setView('model');

  }


  function init() {

    document
      .querySelectorAll(
        '[data-compare-bags]'
      )
      .forEach(
        initCompareBags
      );

  }


  /*
   * Initial page
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }


  /*
   * AJAX product đổi
   */

  document.addEventListener(
    'compare-bags:updated',
    function (event) {

      const root =
        event.detail?.root;

      if (!root) return;

      console.log(
        '[COMPARE] re-init updated compare',
        root
      );

      /*
       * Nếu HTML mới đã có flag
       * thì bỏ flag trước khi init.
       */

      delete root.dataset.compareInitialized;

      initCompareBags(root);

    }
  );


})();